<template>
  <div class="grid" id="listaDocumentosEnvioOperacion">
    <div class="col-12">
      <Accordion>
        <AccordionTab>
          <template slot="header">
            <span>{{
              $t(
                "operacion.detalleOperacion.listaDocumentosEnvioOperacion.titulo"
              )
            }}</span>
          </template>
          <div class="flex col-12">
            <p v-if="documentos.length == 0 && (esProductoNotarial && !tieneActas)">{{ $t("common.noResultados") }}</p>
            <div v-else class="col-12 flex">
              <div v-for="doc in documentos" :key="doc.token" class="grid col-8">
                <div v-if="doc.hasFiles" class="grid flex-column col-12">
                  <div>
                    <p>
                      <b>{{
                        $t(
                          "operacion.detalleOperacion.listaDocumentosEnvioOperacion.tituloSeccionReclamacion",
                          { token: doc.token }
                        )
                      }}</b>
                    </p>
                  </div>
                  <div class="flex">
                    <div class="col-4" v-if="doc.docs && doc.docs.length > 0">
                      <p>
                        {{
                          $t(
                            "operacion.detalleOperacion.listaDocumentosEnvioOperacion.documentosAdjuntos"
                          )
                        }}
                      </p>
                      <Button
                        v-for="file in doc.docs"
                        :key="file"
                        @click.stop="downloadFile(file.fileName, file.value)"
                        v-tooltip.bottom="file.tooltip"
                        class="
                          marginLeft
                          centerButton
                          p-button
                          p-component
                          p-button-transparent
                          p-button-icon-only
                          p-button-outlined
                          status-envio
                        "
                        icon="pi pi-file-pdf"
                        iconPos="left"
                      />
                    </div>
                    <div
                      class="col-4"
                      v-for="tipoEnvio in doc.tiposEnvio"
                      :key="tipoEnvio.type"
                    >
                      <p>{{ getLiteralTipoEnvio(tipoEnvio.type) }}</p>
                      <div v-for="file in tipoEnvio.files" :key="file.filename">
                        <p v-if="file.filename">
                          <b>{{ file.filename }}</b>
                          <Button
                            @click.stop="getDocumentoMinio(file.tipo, file.clave, file.filename)"
                            v-tooltip.bottom="file.tooltip"
                            class="
                              marginLeft
                              centerButton
                              p-button
                              p-component
                              p-button-transparent
                              p-button-icon-only
                              p-button-outlined
                              status-envio
                            "
                            icon="pi pi-file-pdf"
                            iconPos="left"
                          />
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="esProductoNotarial && tieneActas" class="col-4">
                <span v-if="claims && claims.length > 0 && claims[0].actaProvisionalDoc && claims[0].actaDefinitivaDoc">
                  <h3>{{claims[0].actaProvisionalDoc.length > 0 || claims[0].actaDefinitivaDoc.length > 0 ?  $t("detalleReclamacion.actas")  : ''}}</h3>
                  <ActaProvisionalDefinitiva
                    v-if="claims[0].actaProvisionalDoc != []"
                    :title="$t('detalleReclamacion.actaProvisional')"
                    :listActaDocs="claims[0].actaProvisionalDoc"
                  />
                  <ActaProvisionalDefinitiva
                    v-if="claims[0].actaDefinitivaDoc != []"
                    :title="$t('detalleReclamacion.actaDefinitiva')"
                    :listActaDocs="claims[0].actaDefinitivaDoc"
                  />
                </span>
              </div>
            </div>
          </div>
        </AccordionTab>
      </Accordion>
    </div>
  </div>
</template>
<script>
import FilesMixin from "@/utils/files";
import DownloadsMixin from "@/utils/downloads";
import ActaProvisionalDefinitiva from "@/components/portal-cliente/Expedientes/ActaProvisionalDefinitiva.vue";
import { DOWNLOAD_FILE } from "@/graphQLQueries/DocStoreQueries";
import { PRODUCTOS } from "@/resources/constants";

export default {
  name: "ListaDocumentosEnvioOperacion",
  mixins: [FilesMixin, DownloadsMixin],
  props: ["claims"],
  components: {
    ActaProvisionalDefinitiva: ActaProvisionalDefinitiva,
  },
  data() {
    return {
      documentos: [],
      tipoEnvioRequerimiento: "envioRequerimientoBBDD",
      tipoEnvioInclusion: "envioInclusionBBDD",
    };
  },
  methods: {
    getFilesReclamaciones(reclamaciones) {
      return reclamaciones
        .map((r) => {
          const inclusionDocs = this.getFilesReclamacionRec(
            r,
            this.tipoEnvioInclusion
          );
          const requerimientoDocs = this.getFilesReclamacionRec(
            r,
            this.tipoEnvioRequerimiento
          );
          const reclamacionDocs = this.getFilesEnvioReclamacion(
            r, 
            this.tipoEnvioRequerimiento
          );

          return {
            token: r.token,
            tiposEnvio: [
              { type: this.tipoEnvioInclusion, files: inclusionDocs },
              { type: this.tipoEnvioRequerimiento, files: requerimientoDocs },
            ].filter((te) => te.files && te.files.length > 0),
            docs: reclamacionDocs,
            hasEnvioFiles:
              inclusionDocs.length > 0 || requerimientoDocs.length > 0,
            hasReclamacionFiles: reclamacionDocs.length > 0,
            hasFiles:
              inclusionDocs.length > 0 ||
              requerimientoDocs.length > 0 ||
              reclamacionDocs.length > 0,
          };
        })
        .filter((f) => f.hasFiles);
    },
    getLiteralTipoEnvio(tipoEnvio) {
      return tipoEnvio == this.tipoEnvioRequerimiento
        ? this.$t(
            "operacion.detalleOperacion.listaDocumentosEnvioOperacion.documentosEnvioRequerimiento"
          )
        : this.$t(
            "operacion.detalleOperacion.listaDocumentosEnvioOperacion.documentosEnvioInclusion"
          );
    },
    getFilesReclamacion(r) {
      return r.documentosReclamacion.map((doc) => {
        return {
          fileName: doc.filename,
          tooltip: doc.filename,
          id: doc.id,
        };
      });
    },
    getFilesReclamacionRec(r, tipoEnvio) {
      return r[tipoEnvio].documentosReqInc;
    },
    getFilesEnvioReclamacion(rec, tipoEnvio) {
      return [
        {
          name: this.$t("estadoEnvio.certPdf"),
          fileName: this.$t("estadoEnvio.certPdfFileName"),
          tooltip: this.$t("estadoEnvio.descargarCertPdf"),
          value: this.sanitizeBase64(rec[tipoEnvio].certPdf),
        },
        {
          name: this.$t("estadoEnvio.acuseRecibo"),
          fileName: this.$t("estadoEnvio.acuseReciboFileName"),
          tooltip: this.$t("estadoEnvio.descargarAcuseRecibo"),
          value: this.sanitizeBase64(rec[tipoEnvio].stampedContent),
        },
        {
          name: this.$t("estadoEnvio.postalCert"),
          fileName: this.$t("estadoEnvio.postalCertFileName"),
          tooltip: this.$t("estadoEnvio.descargarPostalCert"),
          value: this.sanitizeBase64(rec[tipoEnvio].postalCert),
        },
        {
          name: this.$t("estadoEnvio.postalNote"),
          fileName: this.$t("estadoEnvio.postalNoteFileName"),
          tooltip: this.$t("estadoEnvio.descargarPostalNote"),
          value: this.sanitizeBase64(rec[tipoEnvio].postalNote),
        },
      ].filter((f) => f.value);
    },
    downloadFile(fileName, file) {
      this.download(fileName, file, document);
    },
    downloadFileById(id) {
      this.$apollo
        .query({
          query: DOWNLOAD_FILE,
          variables: {
            id: id,
          },
        })
        .then((data) => {
          var result = data.data.getFileById;
          this.download(result.filename, result.base64, document);
        })
        .catch((error) => {
          console.error("Error al descargar fichero", error);
        });
    },
    esProductoNotarial() {
      const esNotarial =
        this.claims &&
        this.claims.length > 0 &&
        this.claims[0].producto &&
        this.claims[0].producto.codigoProducto ==
          PRODUCTOS.PRODUCTO_ICIRED_NOTARIAL;
      return esNotarial;
    },
    tieneActas() {
      const tieneActaProvisional =
        this.claims &&
        this.claims.length > 0 &&
        this.claims[0].actaProvisionalDoc &&
        this.claims[0].actaProvisionalDoc.length > 0;
      const tieneActaDefinitiva =
        this.claims && this.claims[0].actaDefinitivaDoc && this.claims[0].actaDefinitivaDoc.length > 0;

      return tieneActaProvisional || tieneActaDefinitiva;
    },
  },
  watch: {
    claims(newValue) {
      if (newValue) {
        this.documentos.splice(
          0,
          this.documentos.length,
          ...this.getFilesReclamaciones(newValue)
        );
      }
    },
  },
};
</script>